export function toggle(set: Set<string>, id: string): Set<string> {
  const next = new Set(set);
  if (next.has(id)) {
    next.delete(id);
  } else {
    next.add(id);
  }
  return next;
}

export function rangeIds(orderedIds: string[], anchorId: string | null, targetId: string): string[] {
  if (anchorId === null) return [targetId];
  const anchorIdx = orderedIds.indexOf(anchorId);
  if (anchorIdx === -1) return [targetId];
  const targetIdx = orderedIds.indexOf(targetId);
  if (targetIdx === -1) return [targetId];
  const start = Math.min(anchorIdx, targetIdx);
  const end = Math.max(anchorIdx, targetIdx);
  return orderedIds.slice(start, end + 1);
}
